<script lang="ts" setup>
	import StringMethods from '~/utils/character'

	defineProps<{
		value: StatsSchema
		disableOverflow?: boolean
		isLoading?: boolean
		totalClass?: ClassContext
		cardClass?: ClassContext
		resetClass?: boolean
	}>()
	const replace = StringMethods()
</script>

<template>
	<div>
		<shared-card
			:loading="isLoading"
			:loader-height="174"
			:loader-width="400"
			:ui="{
				container: `bg-white sm:min-h-[165px] items-center w-full flex  sm:py-0 py-6 justify-around sm:px-5 relative xl:border  border-gray-200 rounded-xl  h-full ${[
					cardClass,
					value?.wrapperClass,
					!resetClass ? 'sm:px-5 relative px-4 border ' : ''
				]}`,
				wrapper: 'max-w-full'
			}"
		>
			<div class="relative flex w-full flex-none" :class="{ 'justify-center sm:justify-between': !resetClass }">
				<slot
					container-class="relative border-r last:border-r-0 w-full  md:flex-1 first:px-0 px-4 group transition ease-in-out"
				>
					<a-tooltip color="white" :arrow-point-at-center="true">
						<slot
							:name="value.key"
							:data-items="value"
							:item-class="{
								total: `text-3xl sm:text-[32px] pb-5 xl:text-[40px] font-medium text-blue-950 transition-all ease-in-out group-hover:text-primary-2 ${
									value?.totalClass || ''
								}`,
								title: `text-sm sm:pb-5 pb-3 text-gray-500 font-medium whitespace-pre tracking-wide${
									value?.titleClass || ''
								}`
							}"
						>
							<div class="min-w-[100px] pt-2" :class="value?.containerClass">
								<h4
									class="whitespace-pre pb-3 text-sm font-medium tracking-wide text-gray-500 sm:pb-5"
									:class="value?.titleClass"
								>
									{{ value.title }}
								</h4>

								<div
									class="pb-3 text-3xl font-medium text-blue-950 transition-all ease-in-out group-hover:text-primary-2 sm:text-[32px] xl:text-[40px]"
									:class="[totalClass, value?.totalClass]"
								>
									{{ value.total }}
								</div>
								<slot :name="`${value.key}-p`" />
							</div>
						</slot>

						<template v-if="value.toolTipMessage" #title>
							<span
								class="font-medium text-gray-600"
								v-html="replace.replacePlaceholder(value?.toolTipMessage, value?.title)"
							/>
						</template>
					</a-tooltip>
				</slot>
			</div>
		</shared-card>
	</div>
</template>
